import { actionCreatorFactory } from "typescript-fsa";
import { graphdata } from "../typing/typing";


const actionCreator = actionCreatorFactory("VULNSUMMARYGRAPH");

 const resetData = actionCreator<{data:graphdata[]}>("VULNSUMMARYGRAPH_RESETDATA");

 export const GraphThingyActions = { resetData}


